// extracted by mini-css-extract-plugin
module.exports = {"Ellipsis":"Loading_Ellipsis__FnyPR","Ellipsis1":"Loading_Ellipsis1__19A4h","Ellipsis2":"Loading_Ellipsis2__1zjkH","Ellipsis3":"Loading_Ellipsis3__2kytH"};